import { type ReactNode, type TdHTMLAttributes, type ThHTMLAttributes } from 'react'
import { cn } from '../../lib/utils'

export function Table({ children, className }: { children: ReactNode; className?: string }) {
  return (
    <div className="overflow-x-auto">
      <table className={cn('w-full border-collapse text-13', className)}>{children}</table>
    </div>
  )
}

export function THead({ children }: { children: ReactNode }) {
  return <thead className="bg-surface2 text-xs uppercase text-muted">{children}</thead>
}

export function Th({ className, children, ...props }: ThHTMLAttributes<HTMLTableCellElement>) {
  return (
    <th className={cn('whitespace-nowrap px-4 py-3 text-left font-semibold', className)} {...props}>
      {children}
    </th>
  )
}

/** Cabeçalho de coluna clicável pra ordenar — usado em toda tela que lista lançamentos. */
export function ThOrdenavel<T extends string>({ campo, ativo, desc, onClick, className, children }: {
  campo: T; ativo: T; desc: boolean; onClick: (campo: T) => void
  className?: string; children: ReactNode
}) {
  const selecionado = campo === ativo
  return (
    <Th className={className}>
      <button type="button" className={cn('inline-flex items-center gap-1 hover:text-white', selecionado && 'text-white')} onClick={() => onClick(campo)}>
        {children}
        <i className={cn('text-2xs', selecionado ? (desc ? 'ri-arrow-down-line' : 'ri-arrow-up-line') : 'ri-expand-up-down-line opacity-40')} aria-hidden />
      </button>
    </Th>
  )
}

export function Tr({ className, children, onClick }: { className?: string; children: ReactNode; onClick?: () => void }) {
  return (
    <tr className={cn('border-b border-border/60 transition-colors last:border-b-0 hover:bg-surface2/50', onClick && 'cursor-pointer', className)} onClick={onClick}>
      {children}
    </tr>
  )
}

export function Td({ className, children, ...props }: TdHTMLAttributes<HTMLTableCellElement>) {
  return (
    <td className={cn('px-4 py-3 align-middle', className)} {...props}>
      {children}
    </td>
  )
}
